module.exports = __webpack_public_path__ + "static/media/CSBannerProperties2.7c77aeb1.svg";